<template>
  <router-view></router-view>
</template>

<script>
import api from '@/api';


export default {
  name: 'RapidAIM',
  async created() {
    this.$log.warn("WARN logging is enabled")
    this.$log.info("INFO logging is enabled")
    this.$log.debug('DEBUG logging is enabled')
    if (await api.auth.checkUserSessionIsValid()) {
      this.$store.dispatch('user/read');
    }
  }
};
</script>
